var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 650,
    viewBox: "0 0 600 650",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_61_252)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_61_252",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 600,
    height: 650
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M600 0H0V650H600V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_61_252)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.00402832 0.72168V590.33L180.828 632.757L209.945 615.368L331.996 632.24L373.361 615.179L438.799 650.721L599.996 615.372V0.72168H-0.00402832Z",
    fill: "#F8686D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.0090332 872.65H388.011V570.729L125.099 323.51L-0.0090332 414.789V872.65Z",
    fill: "#843690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.451 523.642L388.011 570.29V872.649H703.451V523.642Z",
    fill: "#D8004D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.203 277.642C409.224 287.708 406.238 297.554 400.622 305.933C395.007 314.313 387.015 320.849 377.657 324.716C368.3 328.582 357.999 329.604 348.056 327.652C338.114 325.7 328.978 320.863 321.805 313.752C314.632 306.641 309.744 297.576 307.76 287.705C305.776 277.833 306.785 267.599 310.66 258.298C314.534 248.996 321.1 241.045 329.525 235.452C337.951 229.858 347.858 226.873 357.992 226.874C364.711 226.867 371.366 228.175 377.576 230.723C383.786 233.27 389.431 237.008 394.187 241.722C398.943 246.436 402.717 252.035 405.295 258.198C407.872 264.361 409.203 270.968 409.209 277.642",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.769 357.887H556.662L682.231 220.103L715.76 147.621L709.843 86.8919L652.646 7.22335L548.114 -26.7339L472.509 -23.4684L394.276 7.87584L344.309 80.3593V158.067L390.988 248.836L477.769 357.887Z",
    fill: "#E50051"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.626 422.204L498.148 443.264L505.543 449.141H528.719L532.411 442.773V422.204L525.262 420L511.209 424.163L499.626 422.204Z",
    fill: "#E50051"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_61_252"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 650,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultBackground);
export default __webpack_public_path__ + "static/media/defaultBackground.4c50c7b9a28a15ab591c72304b6d1e3f.svg";
export { ForwardRef as ReactComponent };